
<template>
    <div class="homeProRecShow">
        <div class="proList">
                <ul class="clearfix">
                    <template v-for="(item,index) in list">
                        <li :key="index">
                        <a :href="'javascript:this.ViewMaterialDetail('+item.id+')'">
                                <img :src="utils.HandleImg(item.img_url,false,1)" alt="">
                                <div class="info">
                                    <div class="name">{{item.title}}</div>
                                    <!-- <div class="company">{{item.company_name}}</div> -->
                                </div>
                            </a>
                        </li>
                    </template>
                </ul>
            </div>
            
            <div class="viewmore">
                <router-link :to="{ name: 'material' }"><span>查看更多</span></router-link>
            </div>
    </div>
</template>

<script>
import EventBus from '../../utils/eventbus'
// import {Loading } from 'element-ui';
export default {
   props: ["id"],
  data(){
    return{
        list:[],
        total:0,
    }
  },
  created(){
    this.GetList();
     window.ViewMaterialDetail=this.ViewDetail;
  },
  components:{
    
  },
  methods:{
     GetList() {
        //    this.loadingInstance = Loading.service({
        //         // 动画中的文字
        //         text:'加载中',
        //         // 要加载动画的容器
        //         target:'.app-container'
        //     });
            var url = "http://api.xincailiao.com/Open/GetMaterialList";
            this.$http.post(url,{pagesize: 5,CategoryId:this.id}).then(function(res){
                if (res.data.status==1){
                    this.list=res.data.ds;
                    this.total=res.data.total;
                    this.loadingInstance.close();
                }
            }.bind(this)).catch(function(){
            });
        },
         ViewDetail(_id){
            EventBus.$emit("pop_material",_id);
        },
  },
  destroyed(){
        window.removeEventListener('scroll',this.scroll_fun)
    },
}
</script>
